import { Icon } from "@iconify/react";
import classes from "./Footer.module.css";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Footer = () => {
  const [aboutToggle, setAboutToggle] = useState(false);
  const [communityToggle, setCommunityToggle] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const aboutToggleHandler = () => {
    setAboutToggle(!aboutToggle);
  };

  const communityToggleHandler = () => {
    setCommunityToggle(!communityToggle);
  };

  const accountHandler = () => {
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }
    navigate("/account");
  };

  return (
    <footer className={classes.footer}>
      <div className={classes.footer__about}>
        <div className={classes.footer__main} onClick={aboutToggleHandler}>
          <p>關於</p>
          <Icon
            icon="akar-icons:plus"
            color="#363636"
            width="20"
            height="20"
            className={classes.add}
            onClick={aboutToggleHandler}
          />
        </div>
        <div
          className={`${aboutToggle ? classes.visible : ""} ${
            classes.footer__list
          }`}
        >
          <ul>
            <li>
              <Link to="about" className={classes.footer__link}>
                關於巧漾
              </Link>
            </li>
            <li>
              <Link to="service" className={classes.footer__link}>
                服務
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={classes.footer__community}>
        <div className={classes.footer__main} onClick={communityToggleHandler}>
          <p>社群</p>
          <Icon
            icon="akar-icons:plus"
            color="#363636"
            width="20"
            height="20"
            className={classes.add}
            onClick={communityToggleHandler}
          />
        </div>
        <div
          className={`${communityToggle ? classes.visible : ""} ${
            classes.footer__list
          }`}
        >
          <ul>
            <li>
              <Link to="contact" className={classes.footer__link}>
                聯絡我們
              </Link>
            </li>
            <li>
              <Link to="/" className={classes.footer__link}>
                常見問題
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={classes.footer__account}>
        <p className={classes.account__link} onClick={accountHandler}>
          會員中心
        </p>
      </div>
      <div className={classes.footer__text}>
        <p>巧漾國際有限公司 版權所有 &copy; </p>
        <p>2022 C.Young International Co., Ltd. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
